import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { PTableCell, PTableHeadCell } from "@porsche-design-system/components-react"
import { shouldForwardProp } from "src/common/shouldForwardProp"

interface SharedProps {
	$isFixed?: boolean
	$width: number
}

const sharedCss = (props: SharedProps) => css`
	min-width: ${props.$width}px;
	max-width: ${props.$width}px;
	${props.$isFixed && `width: ${props.$width}px;`};
`

export const TableCellFixed = styled(PTableCell, { shouldForwardProp })<SharedProps>`${sharedCss}`
export const TableHeadCellFixed = styled(PTableHeadCell, { shouldForwardProp })<SharedProps>`${sharedCss}`
